/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from "redux";
import { actionCreatorAsync } from "./actionHelpers";
import * as api from "../api/serviceTags";
import { IServiceTag } from "../interfaces/ServiceTagsInterface";

export enum Type {
  GET_SERVICETAGS = "GET_SERVICETAGS",
  POST_SERVICETAG = "POST_SERVICETAG"
}

export const getServiceTags: any =
  () =>
  async (dispatch: Dispatch): Promise<any> => {
    await dispatch(actionCreatorAsync(Type.GET_SERVICETAGS, async () => api.getServiceTags()));
  };

export const postServiceTag = (payload: IServiceTag): any => ({
  type: Type.POST_SERVICETAG,
  payload
});
